export default "__VITE_ASSET__DmtY0Lng__"